import { render, staticRenderFns } from "./group_gg.vue?vue&type=template&id=121c10a1&scoped=true&"
import script from "./group_gg.vue?vue&type=script&lang=js&"
export * from "./group_gg.vue?vue&type=script&lang=js&"
import style0 from "./group_gg.vue?vue&type=style&index=0&id=121c10a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121c10a1",
  null
  
)

export default component.exports